// extracted by mini-css-extract-plugin
module.exports = {"speeches":"_3wEu5bL6w2_BlcOiO8Fx74"};